<app-popover (closeCallback)="handleCloseHistoryView()" size="history-model">
  <div popover-header class="header">
    History
  </div>
  <div popover-content *ngIf="historyInfoUnformatted && historyInfo.length">
    <!-- *ngIf="historyInfoUnformatted && historyInfo.length"  -->
    <!-- <div *ngFor="let history of historyInfo">
      <div class="history-wrapper" *ngFor="let info of history.info">
        <div class="left-content-wrapper">
          <div class="history-info">{{info}}</div>
        </div>
        <div class="right-content-wrapper">
          <div class="emp-name ellipsis">{{history.name}}</div>
          <div class="date-wrapper">{{getHistoryDate({history: history})}}</div>
        </div>
      </div>
    </div> -->
    <table>
      <thead class="table-header">
        <th class="header-row">Time</th>
        <th class="header-row">Activity</th>
        <th class="header-row">Details</th>
      </thead>
      <tbody class="table-body"*ngFor="let history of historyInfo">
        <tr class="table-body-row">
          <td class="body-row">{{getHistoryDate({history: history})}} </td>
          <td class="body-row">{{history.info}}</td>
          <td class="body-row">{{history.name}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div popover-content *ngIf="historyInfoUnformatted && !historyInfo.length">
    <div class="no-history-view">
      No history found
    </div>
  </div>
</app-popover>